import { Link } from "react-router-dom";

const SELLER_EMAIL = import.meta.env.VITE_SELLER_EMAIL || "hello@lumosphere.be";
const SELLER_VAT_NUMBER = import.meta.env.VITE_SELLER_VAT_NUMBER || "BE0000.000.000";

const COLUMNS = [
  {
    title: "Univers",
    links: [
      { to: "/location", label: "Location" },
      { to: "/shop", label: "Shop" },
      { to: "/services", label: "Services" },
    ],
  },
  {
    title: "Contact",
    links: [
      { to: `mailto:${SELLER_EMAIL}`, label: SELLER_EMAIL, external: true },
      { to: "/contact", label: "Bruxelles, Belgique" },
    ],
  },
  {
    title: "Suivre",
    links: [
      { to: "https://instagram.com", label: "Instagram", external: true },
      { to: "https://linkedin.com", label: "LinkedIn", external: true },
    ],
  },
];

export function Footer() {
  return (
    <footer className="container pb-10 pt-20">
      <div className="mb-8 flex flex-wrap justify-between gap-10 border-b border-hairline pb-12">
        <Link to="/" className="wordmark text-[26px] leading-none">
          LUMOSPHERE
        </Link>

        <div className="flex flex-wrap gap-x-16 gap-y-8">
          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h2 className="mb-3.5 text-[13px] font-normal text-muted-foreground">{col.title}</h2>
              {col.links.map((link) =>
                "external" in link && link.external ? (
                  <a
                    key={link.label}
                    href={link.to}
                    className="mb-2.5 block text-[14.5px] transition-colors hover:text-brand"
                    // noreferrer avec noopener : sans lui, la page cible peut
                    // lire le referrer complet du panier ou du checkout.
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {link.label}
                  </a>
                ) : (
                  <Link
                    key={link.label}
                    to={link.to}
                    className="mb-2.5 block text-[14.5px] transition-colors hover:text-brand"
                  >
                    {link.label}
                  </Link>
                ),
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-wrap justify-between gap-3 text-[13px] text-muted-foreground">
        <span>© {new Date().getFullYear()} Lumosphere</span>
        <div className="flex gap-6">
          <Link to="/conditions" className="hover:text-foreground">
            Conditions générales
          </Link>
          <span>TVA {SELLER_VAT_NUMBER}</span>
        </div>
      </div>
    </footer>
  );
}
